@if (isLoggedIn()) {
<app-sidenav class="flex h-full" [ngClass]="sidenav().isExtended?'w-full md:w-fit':'hidden md:flex'"></app-sidenav>
}
<div class="relative h-full flex-1 overflow-y-auto bg-[#f6f6f6] md:p-4 container-fluid">
  @if(isLoggedIn()) {
  <div class="hidden md:flex items-center gap-2 md:absolute top-5 right-6">
    <app-notifications></app-notifications>
    <app-profile-settings></app-profile-settings>
  </div>
  }

  <!-- Header for mobile devices  -->
  @if (isLoggedIn()) {
  <div class="w-full px-3 py-1 flex md:hidden items-center gap-2 border-b sticky top-0 bg-[#F6F6F6] z-10">
    <button>
      <svg class="w-[36px] h-[36px] hover:cursor-pointer {{sidenav().isExtended?'':'md:mx-auto'}}"
        (click)="sidenav().isExtended=!sidenav().isExtended" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
    <img src="../assets/logo.png" alt="logo" class="w-[48px] h-[48px]">
    <app-notifications class="ml-auto"></app-notifications>
    <app-profile-settings></app-profile-settings>
  </div>
  }
  <router-outlet></router-outlet>
</div>

<!-- Logout modal -->
<app-modal class="custom-modal-container" [identifier]="'logoutModal'">
  <div class="flex flex-col items-center justify-center gap-1">
    <div class="flex items-center justify-center mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-yellow-500 animate-pulse" fill="none"
        viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>

    <h2 class="text-2xl font-bold text-gray-800 mb-3">
      Confirm Logout
    </h2>

    <p class="text-gray-600 mb-6">
      Are you sure you want to log out of your account?
    </p>

    @if (facebookConnected()) {
    <label for="fb-logout" class="check-container mb-2 flex items-center justify-start gap-1 max-w-fit">
      <input (change)="handleFBLogout($event)" id="fb-logout" type="checkbox" name="checkbox">
      <span class="checkmark rounded-md w-5 h-5 disabled:bg-slate-200"></span>
      <span class="checkmark-label">Log out from Facebook</span>
    </label>
    }

    <div class="flex justify-center gap-1 md:gap-3">
      <button class="btn flex items-center !bg-white !text-black hover:!bg-gray-100" (click)="closeLogoutModal()">
        <span>Cancel</span>
      </button>
      <button class="btn  flex items-center" (click)="logout()">
        <span>Logout
          @if(logoutLoader()) {
          &nbsp;
          <app-loader></app-loader>
          }
        </span>
      </button>
    </div>
  </div>
</app-modal>